export default {
  routes: [
    {
      name: 'warehouses',
      path: '/warehouse',
      component: () => import('./views/TheWarehouses.vue'),
    },

    {
      name: 'warehouse',
      path: '/warehouse/:uuid',
      component: () => import('./views/TheWarehouse.vue'),
    },
  ]
}
